<script setup lang="ts">
import { PropType } from "vue";
import { EditQueueEnum } from "../enums";
import { Cog6ToothIcon, UserGroupIcon } from "tir-style-system/icons/outline";
import { FlagIcon } from "tir-style-system/icons/solid";
/**Параметры */
const props = defineProps({
  /**Текущий таб */
  tab: { type: String as PropType<EditQueueEnum> },
});
/**События */
const emit = defineEmits<{
  /**Обновление таба */
  (e: "update:tab", tab: EditQueueEnum): void;
}>();

/**Выбор таба */
const setTab = (tab: EditQueueEnum) => emit("update:tab", tab);
/**Проверить активен ли таб */
const getTabClass = (_tab: EditQueueEnum) => [
  "edit-queue-modal-wrapper_tabs_item",
  { active: props.tab == _tab },
];
</script>
<template>
  <div class="edit-queue-modal-wrapper">
    <div class="edit-queue-modal-wrapper_tabs">
      <div :class="getTabClass(EditQueueEnum.Main)" @click="setTab(EditQueueEnum.Main)">
        <div class="edit-queue-modal-wrapper_tabs_item__icon">
          <Cog6ToothIcon />
        </div>
        <div class="edit-queue-modal-wrapper_tabs_item__content">Основная информация</div>
      </div>
      <div :class="getTabClass(EditQueueEnum.Employees)" @click="setTab(EditQueueEnum.Employees)">
        <div class="edit-queue-modal-wrapper_tabs_item__icon">
          <UserGroupIcon />
        </div>
        <div class="edit-queue-modal-wrapper_tabs_item__content">Сотрудники</div>
      </div>
      <div :class="getTabClass(EditQueueEnum.Statuses)" @click="setTab(EditQueueEnum.Statuses)">
        <div class="edit-queue-modal-wrapper_tabs_item__icon">
          <div />
        </div>
        <div class="edit-queue-modal-wrapper_tabs_item__content">Статусы</div>
      </div>
      <div :class="getTabClass(EditQueueEnum.Priorities)" @click="setTab(EditQueueEnum.Priorities)">
        <div class="edit-queue-modal-wrapper_tabs_item__icon">
          <FlagIcon />
        </div>
        <div class="edit-queue-modal-wrapper_tabs_item__content">Приоритеты</div>
      </div>
    </div>
    <div class="edit-queue-modal-wrapper_slot">
      <slot />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.edit-queue-modal-wrapper {
  display: flex;
  gap: 1.5rem;
  &_tabs {
    border-radius: 0.5rem;
    border: 0.063rem solid var(--neutral-10, #eaeaeb);
    overflow: hidden;
    background-color: var(--bg-base);
    min-width: 17.5rem;
    height: 40.125rem;
    &_item {
      padding: 0.75rem;
      display: flex;
      align-items: center;
      gap: 0.75rem;
      cursor: pointer;
      transition: background-color 0.2s ease;

      &.active,
      &:hover {
        background-color: var(--neutral-translucent-5, rgba(39, 45, 55, 0.051));
      }

      &__content {
        color: var(--text-primary, #272d37);
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5rem;
      }
      &__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.5rem;
        height: 1.5rem;
        & > div {
          width: 0.75rem;
          height: 0.75rem;
          border-radius: 50%;
          background-color: var(--text-primary);
        }
      }
    }
  }
  &_slot {
    width: 100%;
    padding: 0.75rem;
  }
}
</style>
